import React from 'react';
import ForgetPassword from '../../components/authComponents/forgetPassword';

const Page = () => <ForgetPassword />;

export default Page;
